import React, { Component } from 'react'
import apiService from '../../services/apiservices'
import Select from 'react-select'

class Departments extends Component {
    constructor() {
        super()
        this.state = {
            DepartmentsList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getDepartmentsListData()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getDepartmentsListData = () => {
        apiService.getDepartmentsDetailList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                    if (listData.status === "SUCCESS") {
                        this.setState({
                            DepartmentsList: listData.data ? listData.data : {},
                        })
                    } else {
                        console.error("Filed response from Departments list api")
                    }
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }

    render() {
        let list = {}
        list = Object.keys(this.state.DepartmentsList).map((value,index) => {
            return {
                label : this.state.DepartmentsList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));
       

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={list}
                placeholder="Select Department"
                onChange={(e) => { (e) ? this.props.departmentChange(e) : this.props.departmentChange([])}}
                />
            </div>
        )
    }
}

export default Departments


// WEBPACK FOOTER //
// ./src/modules/Department Teams/Components/DropDowns/Departments.js